import React from 'react';

import { UILoader } from '@futrli/ui-components';

import { CATEGORY_NAME_INDEXES } from '../../../../core/constants';
import { FRForecastLayoutItem, FRForecastLayoutItemDisplayType, ForecastTree } from '../types';
import { ForecastUpdating } from '../../components/forecast-updating';
import { PredictionsTotalsPageWrapper } from '../predictions-totals-page-wrapper';
import { useFRAccountNames } from '../hooks/fr/useFRAccountNames/useFRAccountNames';
import { useFRForecastGrid } from '../hooks/fr/useFRForecastGrid/useFRForecastGrid';
import { usePredictionsInfoContext } from '../../context/predictions-info-context';

const getLayout = (trees: Record<string, ForecastTree>): FRForecastLayoutItem[] => {
  return trees.balance_sheet.tree.map(node => ({
    category: CATEGORY_NAME_INDEXES.income,
    datasource: 'balance_sheet',
    displayType:
      node.type === 'top-level-static-name-only'
        ? FRForecastLayoutItemDisplayType.headingWithTopLevelAccounts
        : FRForecastLayoutItemDisplayType.topLevelAccounts,
    nodes: [node]
  }));
};

export const BalanceSheetFR = () => {
  const accountNameMap = useFRAccountNames();
  const { forecast, forecastReportV2: forecastReport, isLoading, totalCashPredictRow } = usePredictionsInfoContext();
  const { columns, dataGridRows } = useFRForecastGrid(forecast, forecastReport, accountNameMap, getLayout);

  if (!forecastReport && isLoading) {
    return <UILoader isFull />;
  }

  return (
    <>
      <PredictionsTotalsPageWrapper
        columns={columns}
        totalAccountRows={dataGridRows}
        totalCashPredictRow={totalCashPredictRow}
        isBalanceSheet
      />
      <ForecastUpdating show={!!isLoading} />
    </>
  );
};
